import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { Collapse } from '@material-ui/core';

import { instance } from '@api/instance';
import { useOrderContext } from '@hooks';
import PrimaryButton from '@components/PrimaryButton';
import Delete from '@assets/Delete.png';
import { getApiUrl } from '@utils';

import InputNumber from '../InputNumber';
import DelModal from './DelModal';

import {
  useStyles,
  useStylesOrderButton,
  useStylesDetailsButton,
} from './styles';

function OrderCard({ order }) {
  const { pathname } = useLocation();
  const [quantityCocktail, setQuantityCocktail] = useState(
    pathname && pathname === '/orders-screen' ? order.qty || 0 : 0,
  );
  const [isExpand, updateExpand] = useState(false);
  const [details, setProductDetails] = useState('');
  const classes = useStyles();
  const classesOrderButton = useStylesOrderButton();
  const classesDetailsButton = useStylesDetailsButton();
  const price = order.priceIncludingTax;

  const [openDelModal, setOpenDelModal] = useState(false);
  const { order: newOrder, setOrder } = useOrderContext();

  const matchOrders = () => {
    if (pathname === '/orders-screen') {
      setOrder(
        Object.assign(
          newOrder,
          Object.assign(order, { qty: quantityCocktail }),
        ),
      );
    }
  };

  useEffect(matchOrders, [quantityCocktail]);

  const showDetails = async (expand, id) => {
    if (!expand) {
      updateExpand(expand);
      return;
    }
    const requestConfig = {
      method: 'get',
      url: `${getApiUrl()}/products/${id}`,
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };

    const { data } = await instance(requestConfig);

    setProductDetails(data.product);
    updateExpand(expand);
  };

  const handleDel = () => {
    let deletedOrders = newOrder.filter(el => el.id !== order.id);
    setOrder(deletedOrders);
    setOpenDelModal(false);
  };

  const handleButtonClick = operator => () => {
    if (operator === 'plus') {
      setQuantityCocktail(quantityCocktail + 1);
    } else {
      if (quantityCocktail > 1) {
        setQuantityCocktail(quantityCocktail - 1);
      } else {
        setOpenDelModal(true);
      }
    }
  };

  const addOrder = qtyProduct => {
    if (qtyProduct === 1) {
      setQuantityCocktail(1);
    }

    let filteredOrder = newOrder.find(el => el.id === order.id);

    if (filteredOrder) {
      filteredOrder = Object.assign(filteredOrder, {
        qty: qtyProduct,
      });
    } else {
      filteredOrder = Object.assign(order, {
        qty: 1,
      });
    }

    let removedOrders = newOrder.filter(el => el.id !== order.id);
    let finalOrders = removedOrders.concat(filteredOrder);

    const idxZeroQtyItem = finalOrders.findIndex(
      orderItem => orderItem.qty === 0,
    );

    if (idxZeroQtyItem >= 0) {
      finalOrders.splice(idxZeroQtyItem, 1);
      setOrder(finalOrders);
      return;
    }

    setOrder(finalOrders);
  };

  return (
    <div key={order.id}>
      <div className={classes.card}>
        <div className={classes.cardTop}>
          <img className={classes.cardImg} src={order.icon} alt="cocktail" />
          <div className={classes.cardInfo}>
            <Typography className={classes.cardTitle}>{order.name}</Typography>
            <span
              style={{
                height: 1,
                width: '90%',
                border: 'none',
                display: 'flex',
                backgroundColor: '#43566C',
              }}
            ></span>

            <Typography
              variant="subtitle1"
              className={classes.ListPara}
              gutterBottom
            >
              {order.shortDescription}
            </Typography>

            {/* {order.match ? <MatchChip match={order.match * 100} /> : null} */}
          </div>
        </div>
        <Collapse
          in={isExpand}
          timeout="auto"
          unmountOnExit
          style={{ marginLeft: 20, marginRight: 20 }}
        >
          <div className={classes.DiscriptionWrapper}>
            <Typography variant="h6" className={classes.DisHeading}>
              Description
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.DisPara}
              gutterBottom
            >
              {details.longDescription}
            </Typography>
            <span
              style={{
                height: 1,
                width: '90%',
                border: 'none',
                display: 'flex',
                backgroundColor: '#43566C',
              }}
            ></span>
          </div>
          <div className={classes.AllergenWrapper}>
            <Typography className={classes.mainHeading}>Allergens</Typography>
            <div className={classes.Wrapper}>
              {details?.containsAllergens?.map((allergen, idx) => (
                <Typography key={idx} className={classes.List}>
                  {allergen}
                </Typography>
              ))}
            </div>
          </div>
        </Collapse>
        <div className={classes.cardMiddle}>
          <div className={classes.cardActions}>
            <div className={classes.cardPriceNumber}>
              {'€ '}
              {`${price.toFixed(2)}`}
            </div>
            <InputNumber
              quantityCocktail={quantityCocktail}
              handleButtonClick={handleButtonClick}
            />
          </div>
        </div>
        {pathname === '/orders-screen' ? (
          <div className={classes.delContainer}>
            <div
              className={classes.ImgWrapper}
              onClick={() => setOpenDelModal(true)}
            >
              <img className={classes.delImg} src={Delete} alt="cocktail" />
            </div>
            <DelModal
              open={openDelModal}
              handleClose={() => setOpenDelModal(false)}
              handleDel={handleDel}
            />
          </div>
        ) : (
          <div className={classes.orderContainer}>
            <PrimaryButton
              text="Order"
              classesButton={classesOrderButton}
              handleClick={() => addOrder()}
            />
            {!(order?.longDescription || order?.allergens) ? null : (
              <PrimaryButton
                text={isExpand ? 'Close' : 'Details'}
                classesButton={classesDetailsButton}
                handleClick={() => showDetails(!isExpand, order.id)}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderCard;
